export const tryParseJSON = (
  input: unknown,
  loose = false
): Record<any, any> | string | null => {
  if (typeof input === 'object') return input;
  if (typeof input !== 'string') return {};
  try {
    return loose ? tryParseLoose(input) : JSON.parse(input);
  } catch {
    return input;
  }
};

const tryParseLoose = (input: string) => {
  try {
    return JSON.parse(input);
  } catch {
    return parseLooseObject(input);
  }
};

const parseLooseObject = (input: string): Record<string, any> => {
  const firstBrace = input.indexOf('{');
  const lastBrace = input.lastIndexOf('}');
  if (firstBrace === -1 || lastBrace === -1 || lastBrace < firstBrace) {
    throw new Error('No JSON-like object found.');
  }

  const mainPart = input.slice(firstBrace, lastBrace + 1);
  const trailingPart = input.slice(lastBrace + 1).trim();

  // 1️⃣ Replace Python literals
  const jsReady = mainPart
    .replace(/\bNone\b/g, 'null')
    .replace(/\bTrue\b/g, 'true')
    .replace(/\bFalse\b/g, 'false');

  // 2️⃣ Safely evaluate as JS object
  let mainObj: Record<string, any>;
  try {
    // eslint-disable-next-line no-new-func
    mainObj = new Function(`return (${jsReady});`)();
  } catch (err) {
    console.error('Evaluation failed:', jsReady);
    throw new Error('Unable to parse main object');
  }

  // 3️⃣ Parse trailing key-value pairs generically
  const extraObj: Record<string, any> = {};
  if (trailingPart) {
    // Match any key: value sequence, key = word characters
    const regex =
      /^([A-Za-z_][A-Za-z0-9_-]*):([\s\S]*?)(?=^[A-Za-z_][A-Za-z0-9_-]*:|\s*$)/gm;
    let match;
    while ((match = regex.exec(trailingPart)) !== null) {
      const key = match[1].trim();
      const value = match[2].trim();
      extraObj[key] = value;
    }
  }

  return { ...mainObj, ...extraObj };
};
